import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router";
import { CandidateProfile } from "../../../Redux/action/CandidateProfileAction";
import { CandidateProAction } from "../../../Redux/action/CandidateProAction";
import { CiEdit } from "react-icons/ci";
import { RiForbid2Line } from "react-icons/ri";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const PersonalProfile = () => {
  const { userResult } = useSelector((state) => state.Auth);
  const userInfo = useSelector((state) => state?.Profile?.result);
  const fileInputRefPan = useRef(null);
  const fileInputRefAadhar = useRef(null);
  const fileInputRefGovId = useRef(null);
  const fileInputRefGovTax = useRef(null);
  const [loader, setLoader] = useState(false);

  const [profileInfo, setProfileInfo] = useState({
    city: "",
    country: "",
    pincode: "",
    aadharCardNumber: "",
    panCardNumber: "",
    linkedIn: "",
    gender: "",
    hobbies: "",
    interest: "",
    skypeId: "",
    state: "",
    whatsapp: "",
    aadharImage: "",
    panImage: "",
    governmentId: "",
    governmentTaxId: "",
    governmentIdFile: "",
    governmentTaxIdFile: "",
  });

  const isIndian = userInfo?.countryCode === "in";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isDisabled, setIsDisabled] = useState(true);
  const [countryCode, setCountryCode] = useState(userInfo?.countryCode);
  const [whatsappCountryCode, setwhatsappCountryCode] = useState(countryCode);
  const candidateId = userResult?.userid;

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setProfileInfo({ ...profileInfo, [name]: value });
  };

  useEffect(() => {
    dispatch(CandidateProfile(candidateId));
  }, [dispatch, candidateId, isDisabled]);

  useEffect(() => {
    setProfileInfo({
      ...userInfo,
      aadharImage: userInfo?.aadhaarCardUrl,
      panImage: userInfo?.panCardUrl,
      governmentId: userInfo?.governmentId,
      governmentTaxId: userInfo?.governmentTaxId,
      governmentIdFile: userInfo?.governmentIdUrl,
      governmentTaxIdFile: userInfo?.governmentTaxIdUrl,
    });
  }, [userInfo]);

  const validatePan = (pan) => /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan);

  const handleSubmit = (e) => {
    e.preventDefault();

    const fullNumber = `+${countryCode}${profileInfo.mobile}`.replace(
      /\s+/g,
      ""
    );
    const digitsOnly = fullNumber.replace(/\D/g, "");
    const isValid =
      fullNumber.startsWith("+") &&
      digitsOnly.length >= 7 &&
      digitsOnly.length <= 15;

    if (!isValid) {
      toast.error("Invalid phone number");
      return;
    }

    const fullWhatsAppNumber =
      `+${whatsappCountryCode}${profileInfo?.whatsapp}`.replace(/\s+/g, "");
    const whatsAppNumer = fullWhatsAppNumber.replace(/\D/g, "");
    const isValidWhatsApp =
      fullWhatsAppNumber.startsWith("+") &&
      whatsAppNumer.length >= 7 &&
      whatsAppNumer.length <= 15;

    if (!isValidWhatsApp) {
      toast.error("Invalid WhatsApp number");
      return;
    }

    // Validation for India
    if (isIndian && profileInfo.panCardNumber?.trim()) {
      if (!validatePan(profileInfo.panCardNumber.trim())) {
        return toast.error(
          "Invalid PAN card number. It should follow: XXXXX9999X"
        );
      }
    }

    if (isIndian && !profileInfo?.aadharImage) {
      return toast.error("Please upload your Aadhaar Document");
    }
    if (isIndian && profileInfo?.aadharCardNumber?.length !== 12) {
      return toast.error("Aadhaar Number must be 12 digits");
    }

    // Validation
    if (!isIndian) {
      if (!profileInfo.governmentId?.trim()) {
        return toast.error("Please enter your Government ID");
      }
      if (!profileInfo.governmentTaxId?.trim()) {
        return toast.error("Please enter your Government Tax ID");
      }
    }

    let formData = new FormData();
    formData.append(
      "candidateReqDto",
      JSON.stringify({
        ...profileInfo,
        countryCode,
        whatsappCountryCode,
      })
    );

    if (profileInfo.aadharImage && isIndian)
      formData.append("aadhaarCard", profileInfo.aadharImage);
    if (profileInfo.panImage && isIndian)
      formData.append("panCard", profileInfo.panImage);

    if (profileInfo.governmentIdFile && !isIndian)
      formData.append("governmentIdFile", profileInfo.governmentIdFile);
    if (profileInfo.governmentTaxIdFile && !isIndian)
      formData.append("governmentTaxIdFile", profileInfo.governmentTaxIdFile);

    setLoader(true);
    dispatch(CandidateProAction(formData, navigate))
      .then(() => {
        setLoader(false);
        setIsDisabled(true);
        toast.success("Profile updated successfully");
      })
      .catch(() => {
        setLoader(false);
        toast.error("Something went wrong");
      });
  };

  const handleImageChange = (e) => {
    setIsDisabled(false);
    const file = e.target.files[0];
    const { name } = e.target;
    let newProfileInfo = { ...profileInfo, [name]: file };
    const combinedSize =
      (newProfileInfo.aadharImage?.size || 0) +
      (newProfileInfo.panImage?.size || 0) +
      (newProfileInfo.governmentIdFile?.size || 0) +
      (newProfileInfo.governmentTaxIdFile?.size || 0);

    if (combinedSize / 1024 / 1024 < 1) {
      setProfileInfo(newProfileInfo);
    } else {
      toast.error("Combined file size should be less than 1MB");
      e.target.value = null;
    }
  };

  const handleEdit = () => setIsDisabled(!isDisabled);

  const TeamDisabled = profileInfo?.vendorId;

  return (
    <>
      <ToastContainer />
      <div className="can_prof_container">
        <div className="row d-flex justify-content-center align-items-center">
          <div className="card can_prof_main">
            <div className="card-header prof_header d-flex justify-content-between">
              Contact Info
              <span>
                {isDisabled ? (
                  <CiEdit onClick={handleEdit} className="pointer" />
                ) : (
                  <RiForbid2Line
                    color="red"
                    onClick={handleEdit}
                    className="pointer"
                  />
                )}
              </span>
            </div>

            <div className="card-body">
              <form onSubmit={handleSubmit}>
                {/* Email + LinkedIn */}
                <div className="row gx-3 mb-3">
                  <div className="col-sm-6">
                    <label className="small mb-1">
                      Email
                      <span style={{ color: "red", paddingLeft: 4 }}>*</span>
                    </label>
                    <input
                      className="form-control"
                      value={userInfo.email}
                      disabled
                    />
                  </div>
                  <div className="col-sm-6">
                    <label className="small mb-1">LinkedIn</label>
                    <input
                      className="form-control"
                      name="linkedIn"
                      type="url"
                      value={profileInfo?.linkedIn || ""}
                      onChange={handleInputChange}
                      disabled={isDisabled}
                    />
                  </div>
                </div>

                {/* WhatsApp & Mobile (restored) */}
                <div className="row gx-3 mb-3">
                  <div className="col-sm-6">
                    <label className="small mb-1">
                      WhatsApp{" "}
                      <span style={{ color: "red", paddingLeft: 4 }}>*</span>
                    </label>
                    <div className="d-flex align-items-center flex-wrap gap-2">
                      <div>
                        <PhoneInput
                          inputClass="vendorProfilePhoneInput w-100"
                          enableSearch={true}
                          country={
                            userInfo?.countryCode?.toLowerCase?.() || "in"
                          }
                          value={whatsappCountryCode}
                          onChange={(value, countryData) => {
                            const newDialCode = countryData?.dialCode || "";
                            setwhatsappCountryCode(newDialCode);
                          }}
                          disabled={isDisabled}
                        />
                      </div>
                      <div className="flex-grow-1">
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Enter Your WhatsApp Number"
                          name="whatsapp"
                          style={{ marginBottom: 0 }}
                          value={profileInfo?.whatsapp}
                          onChange={(e) =>
                            setProfileInfo({
                              ...profileInfo,
                              whatsapp: e.target.value.slice(0, 15),
                            })
                          }
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <label className="small mb-1">
                      Mobile{" "}
                      <span style={{ color: "red", paddingLeft: 4 }}>*</span>
                    </label>
                    <div className="d-flex align-items-center flex-wrap gap-2">
                      <div>
                        <PhoneInput
                          inputClass="vendorProfilePhoneInput w-100"
                          enableSearch={true}
                          country={userInfo?.countryCode}
                          value={countryCode}
                          onChange={(code) => setCountryCode(code)}
                          disabled={isDisabled || TeamDisabled}
                        />
                      </div>
                      <div className="flex-grow-1">
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Enter Your Mobile Number"
                          name="mobile"
                          style={{ marginBottom: 0 }}
                          value={profileInfo?.mobile}
                          onChange={(e) =>
                            setProfileInfo({
                              ...profileInfo,
                              mobile: e.target.value.slice(0, 15),
                            })
                          }
                          disabled={isDisabled || TeamDisabled}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {isIndian ? (
                  <>
                    {/* India: PAN + Aadhaar */}
                    <div className="row gx-3 mb-3">
                      <div className="col-sm-6">
                        <label className="small mb-1">
                          PAN Number
                          {/* <span style={{ color: "red", paddingLeft: 4 }}>
                            *
                          </span> */}
                        </label>
                        <input
                          className="form-control"
                          name="panCardNumber"
                          value={profileInfo.panCardNumber || ""}
                          onChange={handleInputChange}
                          disabled={isDisabled}
                        />
                      </div>
                      <div className="col-sm-6">
                        <label className="small mb-1">
                          Aadhaar Number{" "}
                          <span style={{ color: "red", paddingLeft: 4 }}>
                            *
                          </span>
                        </label>
                        <input
                          className="form-control"
                          name="aadharCardNumber"
                          value={profileInfo.aadharCardNumber || ""}
                          onChange={handleInputChange}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>

                    <div className="row gx-3 mb-3">
                      {/* PAN File Upload */}
                      <div className="col-sm-6">
                        <label>PAN Document</label>
                        <input
                          type="file"
                          name="panImage"
                          ref={fileInputRefPan}
                          className="form-control"
                          onChange={handleImageChange}
                          disabled={isDisabled}
                          accept="image/*,.pdf"
                        />

                        {userInfo?.panCardUrl && (
                          <div className="mt-2">
                            {userInfo.panCardUrl.endsWith(".pdf") ? (
                              <a
                                href={userInfo.panCardUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-primary btn-sm"
                              >
                                View Uploaded PAN (PDF)
                              </a>
                            ) : (
                              <img
                                src={userInfo.panCardUrl}
                                alt="PAN Document"
                                className="img-thumbnail mt-2"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "cover",
                                }}
                              />
                            )}
                          </div>
                        )}
                      </div>

                      {/* Aadhaar File Upload */}
                      <div className="col-sm-6">
                        <label>Aadhaar Document</label>
                        <span style={{ color: "red", paddingLeft: 4 }}>*</span>
                        <input
                          type="file"
                          name="aadharImage"
                          ref={fileInputRefAadhar}
                          className="form-control"
                          onChange={handleImageChange}
                          disabled={isDisabled}
                          accept="image/*,.pdf"
                        />

                        {userInfo?.aadhaarCardUrl && (
                          <div className="mt-2">
                            {userInfo.aadhaarCardUrl.endsWith(".pdf") ? (
                              <a
                                href={userInfo.aadhaarCardUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-primary btn-sm"
                              >
                                View Uploaded Aadhaar (PDF)
                              </a>
                            ) : (
                              <img
                                src={userInfo.aadhaarCardUrl}
                                alt="Aadhaar Document"
                                className="img-thumbnail mt-2"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "cover",
                                }}
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {/* Global: Gov ID + Tax ID */}
                    <div className="row gx-3 mb-3">
                      <div className="col-sm-6">
                        <label className="small mb-1">
                          Government ID{" "}
                          <span style={{ color: "red", paddingLeft: 4 }}>
                            *
                          </span>
                        </label>
                        <input
                          className="form-control"
                          name="governmentId"
                          value={profileInfo.governmentId || ""}
                          onChange={handleInputChange}
                          disabled={isDisabled}
                        />
                      </div>
                      <div className="col-sm-6">
                        <label className="small mb-1">
                          Government Tax ID{" "}
                          <span style={{ color: "red", paddingLeft: 4 }}>
                            *
                          </span>
                        </label>
                        <input
                          className="form-control"
                          name="governmentTaxId"
                          value={profileInfo.governmentTaxId || ""}
                          onChange={handleInputChange}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>

                    <div className="row gx-3 mb-3">
                      {/* Government ID File */}
                      <div className="col-sm-6">
                        <label>Government ID Document</label>
                        <input
                          type="file"
                          name="governmentIdFile"
                          ref={fileInputRefGovId}
                          className="form-control"
                          onChange={handleImageChange}
                          disabled={isDisabled}
                          accept="image/*,.pdf"
                        />

                        {userInfo?.governmentIdUrl && (
                          <div className="mt-2">
                            {userInfo.governmentIdUrl.endsWith(".pdf") ? (
                              <a
                                href={userInfo.governmentIdUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-primary btn-sm"
                              >
                                View Government ID
                              </a>
                            ) : (
                              <img
                                src={userInfo.governmentIdUrl}
                                alt="Government ID"
                                className="img-thumbnail mt-2"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "cover",
                                }}
                              />
                            )}
                          </div>
                        )}
                      </div>

                      {/* Government Tax File */}
                      <div className="col-sm-6">
                        <label>Government Tax Document</label>
                        <input
                          type="file"
                          name="governmentTaxIdFile"
                          ref={fileInputRefGovTax}
                          className="form-control"
                          onChange={handleImageChange}
                          disabled={isDisabled}
                          accept="image/*,.pdf"
                        />

                        {userInfo?.governmentTaxIdUrl && (
                          <div className="mt-2">
                            {userInfo.governmentTaxIdUrl.endsWith(".pdf") ? (
                              <a
                                href={userInfo.governmentTaxIdUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-primary btn-sm"
                              >
                                View Tax Document (PDF)
                              </a>
                            ) : (
                              <img
                                src={userInfo.governmentTaxIdUrl}
                                alt="Government Tax Document"
                                className="img-thumbnail mt-2"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "cover",
                                }}
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}

                {!isDisabled && (
                  <button
                    className={`can_update_prof_btn add_skill_btn ${
                      isDisabled && "cursor_disabled disabled_btn"
                    }`}
                    disabled={isDisabled || loader}
                    type="submit"
                  >
                    {loader ? "Loading..." : "Save changes"}
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PersonalProfile;
